/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const HomeSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g><path d="M4.187 12.139a.5.5 0 0 0-.19.393v5.555a3 3 0 0 0 3 3h2.5a.5.5 0 0 0 .5-.5V15.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v5.087a.5.5 0 0 0 .5.5h2.5a3 3 0 0 0 3-3v-5.554a.5.5 0 0 0-.192-.393l-7.493-5.897a.5.5 0 0 0-.618 0l-7.507 5.896Z" /><path d="m3.363 11.514 7.713-6.058a1.5 1.5 0 0 1 1.854.001l7.695 6.055a.5.5 0 0 0 .64-.138l.626-.833a.5.5 0 0 0-.09-.692l-3.805-3.014V4.587a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v.664L14.25 3.867l-.002.003-.39-.309a3 3 0 0 0-3.724 0l-.39.31-.003-.004L2.19 9.85a.5.5 0 0 0-.09.692l.626.833a.5.5 0 0 0 .637.14Z" /></g></svg>);
const HomeSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={HomeSolidBase} {...rest} ref={ref} />);
export default HomeSolid;